import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { RadioButton } from "primereact/radiobutton";

import { getProjectPmAction } from "../../../../../redux/action/projectAction";

function PopupFilter(props) {
  const { show, parsed, onHide } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const [type, setType] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");

  const submitFilter = () => {
    const params = {
      q: parsed?.search || "",
      category: category || "",
      type: type || "",
      orderField: parsed.order || "",
      orderDir: parsed.order === "createdAt" ? "desc" : "asc",
      status: status,
      page: 1,
      perpage: 10,
    };
    history.push(
      `/admin/pm/list-project??search=${parsed.search ||
        ""}&type=${type}&category=${category}&status=${status}&order=${parsed?.order ||
        ""}&page=1`
    );
    dispatch(getProjectPmAction(params));
    onHide();
  };

  const resetFilter = () => {
    const params = {
      q: parsed.search,
      category: "",
      type: "",
      status: "",
      orderField: parsed?.order || "",
      orderDir:
        parsed?.order === "createdAt" || !parsed?.order ? "desc" : "asc",
      page: 1,
      perpage: 10,
    };
    dispatch(getProjectPmAction(params));
    setType("");
    setCategory("");
    setStatus("");
    onHide();
  };

  return (
    <div className={`popup-project-filter ${!show && "d-none"}`}>
      <div className="filter-body">
        <div className="sort-by">
          <h3 className="p-mb-3 p-mt-4">Jenis Project</h3>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="category1"
              name="category"
              value=""
              onChange={(e) => setCategory(e.value)}
              checked={category === ""}
            />
            <label htmlFor="category1" className="p-mb-0">
              Semua
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="category2"
              name="category"
              value="public"
              onChange={(e) => setCategory(e.value)}
              checked={category === "public"}
            />
            <label htmlFor="category2" className="p-mb-0">
              Public
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="category3"
              name="category"
              value="private"
              onChange={(e) => setCategory(e.value)}
              checked={category === "private"}
            />
            <label htmlFor="category3" className="p-mb-0">
              Private
            </label>
          </div>
          <h3 className="p-mb-3 p-mt-4">Kategori</h3>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="type1"
              name="type"
              value=""
              onChange={(e) => setType(e.value)}
              checked={type === ""}
            />
            <label htmlFor="category1" className="p-mb-0">
              Semua
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="type2"
              name="type"
              value="article"
              onChange={(e) => setType(e.value)}
              checked={type === "article"}
            />
            <label htmlFor="type2" className="p-mb-0">
              Artikel
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="type3"
              name="type"
              value="pr"
              onChange={(e) => setType(e.value)}
              checked={type === "pr"}
            />
            <label htmlFor="type3" className="p-mb-0">
              Press Release
            </label>
          </div>
          <h3 className="p-mb-3 p-mt-4">Status</h3>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="status1"
              name="status"
              value=""
              onChange={(e) => setStatus(e.value)}
              checked={status === ""}
            />
            <label htmlFor="status1" className="p-mb-0">
              Semua
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="status2"
              name="status"
              value="new"
              onChange={(e) => setStatus(e.value)}
              checked={status === "new"}
            />
            <label htmlFor="status2" className="p-mb-0">
              Baru
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="status3"
              name="status"
              value="published"
              onChange={(e) => setStatus(e.value)}
              checked={status === "published"}
            />
            <label htmlFor="status3" className="p-mb-0">
              Terbit
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="status4"
              name="status"
              value="ongoing"
              onChange={(e) => setStatus(e.value)}
              checked={status === "ongoing"}
            />
            <label htmlFor="status4" className="p-mb-0">
              Berjalan
            </label>
          </div>
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="status5"
              name="status"
              value="done"
              onChange={(e) => setStatus(e.value)}
              checked={status === "done"}
            />
            <label htmlFor="status5" className="p-mb-0">
              Selesai
            </label>
          </div>
        </div>
      </div>
      <div className="filter-footer">
        <div className="button">
          <button className="p-btn reset" onClick={() => resetFilter()}>
            Reset
          </button>
          <button className="p-btn btn-primary" onClick={() => submitFilter()}>
            Terapkan
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupFilter;
